import { z } from 'zod';
// TODO(wave-3): replace with z.enum([...SFX_TOKENS]) once the SFX library
// ships and we have curated names to validate against.
export const sfxRef = z.string().min(1);
//# sourceMappingURL=sfx-tokens.js.map